module.exports = __webpack_public_path__ + "be1e6672908f2d76091de9ac60983c89.otf";